import { useEffect, useState } from 'react'

import type { Pair } from '@/sdk'

/** Selección de posición LP para el hub Nutrimatic (desktop readout + perform). */
export function useLiquidityPositionsHubFlow(pairs: Pair[]) {
  const [selectedPair, setSelectedPair] = useState<Pair | null>(null)

  useEffect(() => {
    if (pairs.length === 0) {
      setSelectedPair(null)
      return
    }
    setSelectedPair((current) => {
      if (current && pairs.some((p) => p.liquidityToken.address === current.liquidityToken.address)) {
        return current
      }
      return pairs[0]
    })
  }, [pairs])

  return { selectedPair, setSelectedPair }
}
